import { LocalShipment } from './local-shipment.model';
import * as moment from 'moment';
import { StopType } from '../../shared/stop-type.model';
import { LocalStopLocation } from './local-stop-location.model';

export class LocalStop {

  public id: string;
  public stopId: string;
  public type: StopType;
  public plannedArrival: moment.Moment;
  public plannedDeparture: moment.Moment;
  public actualArrival: moment.Moment;
  public actualDeparture: moment.Moment;
  public eta: any;
  public location: LocalStopLocation;
  public shipments: LocalShipment[] = [];

  public mapExpanded = false;

  static fromDto(s): LocalStop {
    const stop = new LocalStop();

    if (!s) {
      return null;
    }

    stop.id               = s.id;
    stop.stopId           = s.stop_id;
    stop.type             = s.type;
    stop.plannedArrival   = s.planned_arrival ? moment(s.planned_arrival) : null;
    stop.plannedDeparture = s.planned_departure ? moment(s.planned_departure) : null;
    stop.actualArrival    = s.actual_arrival ? moment(s.actual_arrival) : null;
    stop.actualDeparture  = s.actual_departure ? moment(s.actual_departure) : null;
    stop.eta              = s.eta ? moment(s.eta) : null;
    stop.location         = LocalStopLocation.fromDto(s.location);
    stop.shipments        = s.shipments.map((shipment) => LocalShipment.fromDto(shipment));

    return stop;
  }

  expandMap() {
    this.mapExpanded = !this.mapExpanded;
  }
}
